import {
  createStoreSlice as createSlice,
  type PayloadAction,
} from '@/store/core';
import { RootState } from '../store';
import { StoreError } from '@/types/storeError.interface';
import { UserActivities } from '@/typings';

interface UserState {
  loading: boolean;
  error: StoreError | null;
  lastActivities: UserActivities;
}

const initialState: UserState = {
  lastActivities: [],
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userLoading: state => {
      state.loading = true;
    },
    fetchLastActivitiesSuccess: (
      state,
      action: PayloadAction<UserActivities>,
    ) => {
      state.loading = false;
      state.error = null;
      state.lastActivities = action.payload;
    },
    fetchUserActivitiesFailure: (state, action: PayloadAction<StoreError>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  userLoading,
  fetchLastActivitiesSuccess,
  fetchUserActivitiesFailure,
} = userSlice.actions;

export const selectUser = (state: RootState) =>
  state[userSlice.name] as typeof initialState;
